import getElementTopOffset from 'helpers/get-element-top-offset';

export const ELEMENT_SCROLL_TOP = 50;
export const ELEMENT_SCROLL_TOP_SPACE = ELEMENT_SCROLL_TOP + 10;

const scrollToElement = (elementId: string): void => {
    const elementDiv = document.getElementById(elementId);

    if (elementDiv) {
        setTimeout(() => {
            window.scrollTo({
                top: getElementTopOffset(elementDiv) - ELEMENT_SCROLL_TOP,
                behavior: 'smooth'
            });
        }, 0);
    }
};

export default scrollToElement;
